import { GitBranch, Check, X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface GitPushResultData {
  success?: boolean;
  message?: string;
  branch?: string;
  commits?: number;
  error?: string;
}

interface GitPushResultWidgetProps {
  data: GitPushResultData;
}

export function GitPushResultWidget({ data }: GitPushResultWidgetProps) {
  if (!data) return null;
  const success = data.success !== false && !data.error;

  return (
    <Card
      variant={success ? "success" : "error"}
      padding="sm"
      className="max-w-md animate-slide-up"
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-intri-bg/30">
          {success ? (
            <Check size={16} className="text-intri-success" />
          ) : (
            <X size={16} className="text-intri-error" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-intri-text">
            {success ? "Pushed" : "Push failed"}
          </p>
          <p className="text-xs text-intri-dim mt-0.5 truncate">
            {data.error ?? data.message ?? (success ? "Changes pushed to remote" : "Unknown error")}
          </p>
        </div>
        {data.branch && (
          <Badge variant={success ? "success" : "error"} size="sm">
            <GitBranch size={10} />
            {data.branch}
          </Badge>
        )}
      </div>
    </Card>
  );
}
